// extracted by mini-css-extract-plugin
module.exports = {"receive_compoment":"Receive_receive_compoment__vRbZy","no_active_modal":"Receive_no_active_modal__otvPe"};